import {
  RISK_RULES_LIST_SUCCESS,
  RISK_RULES_LIST_FAILED,
  RESET_RISK_RULES_LIST,
  LOADING_RISK_RULES_LIST,
  NETWORK_ERROR_RISK_RULES_LIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetRiskRulesList = () => {
  return { type: RESET_RISK_RULES_LIST };
};

const getriskRuleList = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_RISK_RULES_LIST });
  await partnerServices
    .post("getRiskRulesList", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "Success":
          dispatch(riskRulesListsuccess(res.data));
          break;
        default:
          dispatch(riskRulesListFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_RISK_RULES_LIST, payload: err });
    });
};
function riskRulesListsuccess(data) {
  return {
    type: RISK_RULES_LIST_SUCCESS,
    payload: data,
  };
}
function riskRulesListFailed(data) {
  return {
    type: RISK_RULES_LIST_FAILED,
    payload: data,
  };
}

export { resetRiskRulesList, getriskRuleList };
